export default {
  MINUTES: "minutes",
  HOUR: "hour",
  DAY: "day",
};
